import React from "react";
import { MediaPlacementsModal } from "@coworker/apprestructured/src/media-maintenance/components/MediaPlacementSection/MediaPlacementsModal/MediaPlacementsModal";
import { useMediasAndArticleCount } from "../../hooks/useMediasAndArticleCount";
import { TaskTypeNames } from "@coworker/apprestructured/src/task-management/constants/TaskTypeNames";
import { useAllTaskTypes } from "@coworker/apprestructured/src/task-management/services/useTaskTypes";
import { filterMainArticles } from "../../Helpers/articleHelpers";
import { Article } from "../../types/article";
import { ModalTypes } from "../../types/views";
import { useTranslation } from "@coworker/locales";

interface SingleArticleMediaPlacementsModalProps {
  modalVisibility: boolean;
  selectedArticles: Article[];
  storeId: string;
  mediaId: string;
  onTriggerNewModal: (modalType: ModalTypes) => void;
}

export const SingleArticleMediaPlacementsModal = ({
  modalVisibility,
  selectedArticles,
  storeId,
  mediaId,
  onTriggerNewModal,
}: SingleArticleMediaPlacementsModalProps) => {
  const { t } = useTranslation();
  const { data: taskTypes } = useAllTaskTypes();
  const singleArticle = filterMainArticles(selectedArticles)[0];

  const {
    data: mediasAndArticleCount,
    isLoading,
    isError,
  } = useMediasAndArticleCount(
    modalVisibility ? singleArticle?.productArticleId : undefined,
    modalVisibility ? storeId : undefined
  );

  if (!modalVisibility || !singleArticle) {
    return null;
  }

  const multipleMediaTaskId = taskTypes?.find(
    (type) => type.name === TaskTypeNames.MEDIA_MAINTENANCE_MULTIPLE_MEDIA
  )?.id;

  const filteredMedias = mediasAndArticleCount?.filter(
    (media) => !media.parentArticleCombinationNumber
  );

  return (
    <MediaPlacementsModal
      itemNoAndType={{
        no: singleArticle.productArticleId,
        type: singleArticle.productArticleType,
      }}
      showModal={modalVisibility}
      onClose={() => onTriggerNewModal(ModalTypes.KEEP_SELECTION)}
      mediasAndArticleCount={filteredMedias ?? []}
      title={t("createTaskString")}
      showCheckBox={true}
      showFooter={true}
      taskTypeId={multipleMediaTaskId}
      mediaId={mediaId}
      hasMediasLoadError={
        !isLoading && (isError || mediasAndArticleCount == null)
      }
    />
  );
};
